import React from 'react';

import Skeleton from 'components/Skeleton';

const DashboardPlansSkeleton: React.FC = () => {
  return <Skeleton variant="rect" height="100%" />;
};

export default DashboardPlansSkeleton;
